// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"c703e3ac","166":"2f649c39","340":"c03364da","900":"9e78e25d"}[chunkId] + ".chunk.css";
};